export const technologyStacks = [
  {
    title: '構建工具',
    desp: 'Webpack5.x'
  },
  {
    title: '前端框架',
    desp: 'Vue 3.x'
  },
  {
    title: 'UI框架',
    desp: 'Element Plus'
  },
  {
    title: '可視化',
    desp: 'Echart5.x'
  },
  {
    title: '文本編輯器',
    desp: 'WangEditor'
  },
  {
    title: 'Git Hook 工具',
    desp: 'husky'
  },
  {
    title: '程式碼規範',
    desp: 'EditorConfig + Prettier + ESLint'
  },
  {
    title: '提交規範',
    desp: 'Commitizen + Commitlint'
  },
  {
    title: '組件模板建構',
    desp: 'plop'
  }
]
